Ext.define('SA.model.GeoUnits', {
    constructor({geoUnits, enabledIds}) {
        this.geoUnits = geoUnits;
        this.enabledIds = enabledIds;
    },

    getEnabledSubGeoUnitsForLocation(location) {
        var locationGeoUnitId = location.getGeoUnitId(),
            locationGeoUnit = this.geoUnits.find(geoUnit => geoUnit.hasId(locationGeoUnitId)),
            subGeoUnits = locationGeoUnit.getSubUnits();

        return subGeoUnits.filter(subUnit => this.enabledIds.includes(subUnit.getId()));
    },

    getUnitsWithEnabledSubUnits() {
        return this.geoUnits.filter(unit => {
            var enabledSubUnits = unit.getSubUnits().filter(subUnit => this.enabledIds.includes(subUnit.getId()));

            return enabledSubUnits.length > 0;
        });
    },

    setEnabledIds(enabledIds) {
        this.enabledIds = enabledIds;
    }
});